import { InputText, InputTextProps } from 'primereact/inputtext';
import { withFormControl } from '../with-form-control';

export const FormInputText = withFormControl<InputTextProps>((props) => {
  return <InputText {...props} />;
});
